(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
    .directive('uploadPane', ['$timeout', '$rootScope', '$translate', 'MessageManager', 'BrowserService', 'SignalProvider', 'AppConstants',
        function ($timeout, $rootScope, $translate, MessageManager, BrowserService, SignalProvider, AppConstants) {
            return {
                restrict: 'E',
                transclude: true,
                scope: false,
                link: function(scope, element, attr) {
                    var dropzone = 'page-border'; // Define the dropzone for that should be highlighted on hover.
                    scope.inDocumentView = (scope.layout.view === AppConstants.LayoutViewTypes.VIEW_DOCUMENT_LAYOUT);

                    var dragStartTarget = null;
                    
                    function dragOverListener(e) {
                        if (dragStartTarget) {
                            //If there's a target element populated by the "start" handler, then it's an internal drag and we don't care about that situtation
                            return;
                        }
                        // Check if the border hide timer is set and cancel it.
                        var dragTimer = window.dragTimer;
                        if (window.dragInProgress && dragTimer) {
                            $timeout.cancel(dragTimer);
                        }
                        // Show the drop zone border and indicate drag in progress.
                        $('#' + dropzone).removeClass('disabled').addClass('enabled');
                        window.dragInProgress = true;
                        $rootScope.$broadcast(SignalProvider.Document.StartDragging);

                        // Set a timer to hide the border when the drag event is concluded.
                        window.dragTimer = $timeout(function() {
                            dragStartTarget = null;
                            window.dragInProgress = false;
                            $('#' + dropzone).removeClass('enabled').addClass('disabled');
                            $rootScope.$broadcast(SignalProvider.Document.StopDragging);
                        }, 500);
                    }

                    // This listener is solely for preventing folder upload in IE.
                    // Drop a folder does not trigger any event in file upload widget.
                    function dropListener(e) {
                        dragStartTarget = null;
                        if (!e.originalEvent.dataTransfer || !e.originalEvent.dataTransfer.files) {
                            // skip if the drop event does not have any file data. This means the drop event is 
                            // not emit by dragging and dropping file.
                            return;
                        }
                        if(BrowserService.isIE()) {
                            var files = e.originalEvent.dataTransfer.files;
                            var file;
                            var hasFolder = false;
                            for(var i=0; i<files.length ; i++) {
                                file = files[i];
                                if(!file.type) {
                                    hasFolder = true;
                                    break;
                                }
                            }
                            // For IE, files is empty if the dropped item is a folder
                            if(hasFolder ||files.length === 0) {
                                MessageManager.addInfoMessage($translate.instant('MESSAGES.FOLDER_UPLOAD_FAIL_BROWSER_NOT_SUPPORT'));
                            }
                        }
                    }

                    function dragStartListener(e) {
                        dragStartTarget = e.target;
                    }

                    // Intercept the dragover event and display the drop zone page border.
                    $(document).on('dragover', dragOverListener);
                    $(document).on('dragstart', dragStartListener);
                    $(document).on('drop', dropListener);
                    scope.$on('$destroy', function() {
                        $(document).off('dragover', dragOverListener);
                        $(document).off('dragstart', dragStartListener);
                        $(document).off('drop', dropListener);
                    });
                },
                templateUrl : './shared/file_upload_mask.html'
            };
        }
    ]);
}());